var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-row align-center"},[_c('div',{staticClass:"sl-title my-5"},[_vm._v("Password")]),_c('v-spacer'),_c('Update')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }